import React from "react";

interface ICountryFlagIcon {
  iso2Code: string;
}

export const CountryFlagIcon: React.FC<ICountryFlagIcon> = ({ iso2Code }) => {
  return <span className={`fi h-[0.8rem] fi-${iso2Code.toLowerCase()}`} />;
};
